module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canPerformUserActions && _vm.user.isCarrier && _vm.user.isNotActivated) ? _c('ul', {
    staticClass: "nav nav-actions"
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.handleCarrierActiviation
    }
  }, [(_vm.performingCarrierActivation) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("\n        Activate Carrier Account\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.canPerformUserActions && _vm.user.isNotArchived && _vm.user.isActivated) ? _c('ul', {
    staticClass: "nav nav-actions"
  }, [(_vm.user.isUnverified) ? _c('li', [_c('a', {
    on: {
      "click": _vm.handleVerificationMail
    }
  }, [(_vm.performingUserVerificationMail) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-send fa-fw"
  }), _vm._v("\n        Verification Email\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.user.isUnverified) ? _c('li', [_c('a', {
    on: {
      "click": _vm.handleManualVerification
    }
  }, [(_vm.performingUserManualVerification) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-check fa-fw"
  }), _vm._v("\n        Manual Verification\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.user.isEnabled) ? _c('li', [_c('a', {
    on: {
      "click": _vm.handleDisable
    }
  }, [(_vm.performingUserDisabling) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-times fa-fw"
  }), _vm._v("\n        Disable User\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.user.isDisabled) ? _c('li', [_c('a', {
    on: {
      "click": _vm.handleEnable
    }
  }, [(_vm.performingUserEnabling) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-refresh fa-fw"
  }), _vm._v("\n        Enable User\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.user.isNotArchived) ? _c('li', [_c('a', {
    on: {
      "click": _vm.handleArchive
    }
  }, [(_vm.performingUserArchive) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-archive fa-fw"
  }), _vm._v("\n        Archive User\n      ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.user.isClientOrCarrier) ? _c('div', {
    staticClass: "row m-b-lg"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-9"
  }, [_c('account-credit')], 1), _vm._v(" "), (_vm.editingOwnDetails || _vm.$user.isAdmin) ? _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block btn-sm m-t-sm",
    attrs: {
      "to": _vm.routeToCreditNotes
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" Credit Notes")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('form', {
    staticClass: "form-material",
    attrs: {
      "data-vv-scope": "account"
    }
  }, [_c('h2', [_vm._v("Account Details")]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "row row-clear-md-6"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('account.name')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "First Name",
      "name": "name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('account.surname')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Surname")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.surname),
      expression: "surname"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Surname",
      "name": "surname"
    },
    domProps: {
      "value": (_vm.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surname = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('account.mobile')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mobile Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Mobile Number",
      "name": "mobile"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('account.email')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email Address",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), [_c('h2', [_vm._v("Company Details")]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('account.company_name')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Entity Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Entity Name",
      "name": "company_name"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row row-clear-md-6"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('account.company_phone')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.companyPhone),
      expression: "companyPhone"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Phone Number",
      "name": "company_phone"
    },
    domProps: {
      "value": (_vm.companyPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyPhone = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('account.company_abn')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("ABN")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.companyAbn),
      expression: "companyAbn"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "ABN",
      "name": "company_abn"
    },
    domProps: {
      "value": (_vm.companyAbn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyAbn = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('h2', [_vm._v("Billing Address")]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('account.address_line_one')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Line 1")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.addressLineOne),
      expression: "addressLineOne"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Line 1",
      "name": "address_line_one"
    },
    domProps: {
      "value": (_vm.addressLineOne)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressLineOne = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Line 2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressLineTwo),
      expression: "addressLineTwo"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Line 2",
      "name": "address_line_two"
    },
    domProps: {
      "value": (_vm.addressLineTwo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressLineTwo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('account.suburb')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Suburb")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.suburb),
      expression: "suburb"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Suburb",
      "name": "suburb"
    },
    domProps: {
      "value": (_vm.suburb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.suburb = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row row-clear-md-6"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('account.state')
    }
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('selectize', {
    directives: [{
      name: "validate",
      rawName: "v-validate:state",
      value: ('required'),
      expression: "'required'",
      arg: "state"
    }],
    attrs: {
      "data-vv-name": "state",
      "name": "state",
      "options": _vm.stateOptions
    },
    model: {
      value: (_vm.state),
      callback: function($$v) {
        _vm.state = $$v
      },
      expression: "state"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('account.postcode')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Postcode",
      "name": "postcode"
    },
    domProps: {
      "value": (_vm.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postcode = $event.target.value
      }
    }
  })])])])])], _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('ladda-button', {
    attrs: {
      "type": "success",
      "on-click": _vm.handleSaveAccountDetails
    }
  }, [_vm._v("Save Changes")])], 1)], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userIsCarrier),
      expression: "userIsCarrier"
    }],
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('form', {
    staticClass: "form-material"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "checkbox checkbox-primary pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_driver),
      expression: "is_driver"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-terms",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.is_driver) ? _vm._i(_vm.is_driver, null) > -1 : (_vm.is_driver)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.is_driver,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.is_driver = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.is_driver = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.is_driver = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-terms"
    }
  }, [_vm._v("\n                I am also a truck driver\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), (_vm.is_driver) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-4"
  }, [_c('photo-cropper', {
    attrs: {
      "name": "driver",
      "photo-storage-path": _vm.photoPath,
      "original-name": _vm.photoName,
      "original-data-uri": _vm.originalPhotoDataUri,
      "class-name": "profile-photo",
      "label-text": "Profile Photo"
    },
    model: {
      value: (_vm.photo),
      callback: function($$v) {
        _vm.photo = $$v
      },
      expression: "photo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-lg-8"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Drivers Licence")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licence),
      expression: "licence"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Drivers Licence"
    },
    domProps: {
      "value": (_vm.licence)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.licence = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Licence Expiry")]), _vm._v(" "), _c('date-range', {
    directives: [{
      name: "float-label",
      rawName: "v-float-label"
    }],
    attrs: {
      "name": "licence_expiry",
      "single-date-picker": true,
      "opens": "right"
    },
    model: {
      value: (_vm.licenceExpiry),
      callback: function($$v) {
        _vm.licenceExpiry = $$v
      },
      expression: "licenceExpiry"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('ladda-button', {
    attrs: {
      "type": "info",
      "on-click": _vm.handleSaveDriverDetails
    }
  }, [_vm._v("Save Details")])], 1)])])]), _vm._v(" "), (_vm.canUploadInsuranceDocument) ? _c('div', {
    staticClass: "ibox"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-documents"
  }, [_vm._l((_vm.user.documents), function(document) {
    return _c('li', {
      key: document.id
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-8 col-md-5 col-lg-6"
    }, [_c('p', {
      staticClass: "material-details"
    }, [_c('strong', [_vm._v("Document")]), _c('br'), _vm._v("\n                " + _vm._s(document.title) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 col-md-2 col-lg-2"
    }, [_c('p', {
      staticClass: "material-details"
    }, [_c('strong', [_vm._v("Expires")]), _c('br'), _vm._v("\n                " + _vm._s(document.expiry ? document.expiry : '–') + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-5 col-lg-4"
    }, [_c('div', {
      staticClass: "btn-toolbar"
    }, [_c('a', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "href": _vm.getDocumentDownloadUrl(document)
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Download")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-sm btn-info",
      on: {
        "click": function($event) {
          _vm.handleEditDocument(document)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          _vm.handleDeleteDocument(document)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])])
  }), _vm._v(" "), (_vm.noUserDocuments) ? _c('li', {
    staticClass: "text-muted text-center",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("No insurance documents")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "document-details-collapse collapse"
  }, [_c('div', {
    staticClass: "ibox-footer"
  }, [(_vm.editingDocument) ? _c('h4', [_vm._v("Edit Document")]) : _c('h4', [_vm._v("Add Document")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "document"
    }
  }, [_c('div', {
    staticClass: "col-sm-8 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Document Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insuranceDocument.title),
      expression: "insuranceDocument.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.insuranceDocument.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.insuranceDocument.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Expires")]), _vm._v(" "), _c('date-range', {
    attrs: {
      "name": "expiry",
      "single-date-picker": true,
      "opens": "right"
    },
    model: {
      value: (_vm.insuranceDocument.expiry),
      callback: function($$v) {
        _vm.insuranceDocument.expiry = $$v
      },
      expression: "insuranceDocument.expiry"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('document.file')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("File")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.insuranceDocument.file_name ? _vm.insuranceDocument.file_name : null
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "btn btn-primary btn-sm m-t-md btn-block",
    attrs: {
      "for": "insurance_document"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "sr-only",
    attrs: {
      "type": "file",
      "id": "insurance_document",
      "name": "file"
    },
    on: {
      "change": _vm.handleFileSelection,
      "input": _vm.handleFileSelection
    }
  }), _vm._v("\n                    Select File\n                  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.editingDocument) ? _c('ladda-button', {
    staticClass: "m-t-md m-b-md",
    attrs: {
      "type": "success",
      "size": "small",
      "on-click": _vm.handleSaveDocument
    }
  }, [_vm._v("Save Changes")]) : _c('ladda-button', {
    staticClass: "m-t-md m-b-md",
    attrs: {
      "type": "success",
      "size": "small",
      "on-click": _vm.handleSaveDocument
    }
  }, [_vm._v("Add Document")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer ibox-footer-document-control text-center",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.handleAddDocument
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Document\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$user.isCarrier),
      expression: "$user.isCarrier"
    }],
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('form', {
    staticClass: "form-material",
    attrs: {
      "data-vv-scope": "payment"
    }
  }, [_c('h2', [_vm._v("Payment Details")]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control form-group",
    class: {
      'has-error': _vm.errors.has('payment.accountName')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Account Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountName),
      expression: "accountName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "accountName",
      "placeholder": "Account Name"
    },
    domProps: {
      "value": (_vm.accountName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accountName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control form-group",
    class: {
      'has-error': _vm.errors.has('payment.bsb')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("BSB")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bsb),
      expression: "bsb"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "bsb",
      "placeholder": "BSB"
    },
    domProps: {
      "value": (_vm.bsb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bsb = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control form-group",
    class: {
      'has-error': _vm.errors.has('payment.accountNumber')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Account Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountNumber),
      expression: "accountNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "accountNumber",
      "placeholder": "Account Number"
    },
    domProps: {
      "value": (_vm.accountNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accountNumber = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('ladda-button', {
    attrs: {
      "type": "success",
      "on-click": _vm.handleSavePaymentDetails
    }
  }, [_vm._v("Save Details")])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editingOwnDetails),
      expression: "editingOwnDetails"
    }],
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('form', {
    staticClass: "form-material",
    attrs: {
      "data-vv-scope": "password"
    }
  }, [_c('h2', [_vm._v("Password Change")]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "row row-clear-md-6"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('password.password_current')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Current Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password.current),
      expression: "password.current"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Current Password",
      "name": "password_current"
    },
    domProps: {
      "value": (_vm.password.current)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password.current = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-clear-md-6"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('password.password_new')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password_new_confirmation'),
      expression: "'required|confirmed:password_new_confirmation'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password.new),
      expression: "password.new"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "New Password",
      "name": "password_new"
    },
    domProps: {
      "value": (_vm.password.new)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password.new = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('password.password_new_confirmation')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Repeat New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password.newConfirmation),
      expression: "password.newConfirmation"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Repeat New Password",
      "name": "password_new_confirmation"
    },
    domProps: {
      "value": (_vm.password.newConfirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password.newConfirmation = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('ladda-button', {
    attrs: {
      "type": "info",
      "on-click": _vm.handleChangePassword
    }
  }, [_vm._v("Change Password")])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canChangeAccountType),
      expression: "canChangeAccountType"
    }],
    staticClass: "ibox"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "admins"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('admins.role')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Account Type")]), _vm._v(" "), _c('selectize', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.accountRoleOptions,
      "disable-delete": true,
      "name": "role"
    },
    model: {
      value: (_vm.role),
      callback: function($$v) {
        _vm.role = $$v
      },
      expression: "role"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('admins.parent')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Parent")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.parentOptions,
      "track-by": "id",
      "label": "text",
      "placeholder": "Select Parent",
      "allowEmpty": false
    },
    model: {
      value: (_vm.parent),
      callback: function($$v) {
        _vm.parent = $$v
      },
      expression: "parent"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-4"
  }, [(_vm.canChangeCommission) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('admins.commission')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Commission")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commission),
      expression: "commission"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal|between:0,100'),
      expression: "'required|decimal|between:0,100'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-vv-scope": "admins",
      "name": "commission"
    },
    domProps: {
      "value": (_vm.commission)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commission = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("%")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 text-right"
  }, [_c('ladda-button', {
    staticClass: "btn-change-account-type m-t-md",
    attrs: {
      "type": "info",
      "size": "small",
      "on-click": _vm.handleSaveRoleAndCommission
    }
  }, [_vm._v("Save")])], 1)])])])]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', [_vm._v("My Driving Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("Insurance Documents "), _c('a', {
    staticClass: "btn btn-circle btn-info pull-right",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": ".modal-insurance-documents"
    }
  }, [_c('i', {
    staticClass: "fa fa-question"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('strong', [_vm._v("Account Settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-insurance-documents",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n          Insurance Documents\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "m-t-md strong"
  }, [_vm._v("Please upload the following current documents:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Comprehensive Insurance (include the schedule of trucks)")]), _vm._v(" "), _c('li', [_vm._v("Public Liability ($10,000,000 or more)")]), _vm._v(" "), _c('li', [_vm._v("Marine Transit ($100,000 or more)")]), _vm._v(" "), _c('li', [_vm._v("Prime Mover Registration Certificates")]), _vm._v(" "), _c('li', [_vm._v("Workers Compensation Certificate (if applicable)")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-547ba214"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Form.vue
// module id = 1005
// module chunks = 0